import { HIVE_STATIC_VERSION, MARKETPLACE, REGION } from 'root/widgets/constants';
import { PGLoginConfig } from 'root/widgets/pg-login/types';

const commonConfig = {
  AUTH_API_HOST: 'https://auth.staging.guruestate.com',
  USERS_API_HOST: 'https://users-api.kgw.staging.guruestate.com',
  GOOGLE_CLIENT_ID: '367223124563-nqbh60veth48kr448f62mflkasd0kpmp.apps.googleusercontent.com',
  FACEBOOK_CLIENT_ID: '751052508373579',
  APPLE_CLIENT_ID: 'com.propertyguru.www',
  PG_LOGO_URL: `https://cdn-staging.pgimgs.com/hive-ui/static/${HIVE_STATIC_VERSION}/logo/pg.svg`,
};
const config: Record<string, PGLoginConfig> = {
  [`${REGION.SG}-${MARKETPLACE.PG}`]: {
    ...commonConfig,
    GOOGLE_CLIENT_ID: '367223124563-qrc1uo9idbccc697glapnaf7lcqd6jh3.apps.googleusercontent.com',
    FACEBOOK_CLIENT_ID: '1493336990969744',
    GURULAND_HOST: 'https://www.staging.propertyguru.com.sg',
    SYMBIOSIS_API_HOST: 'https://symbiosis.staging.propertyguru.com.sg',
  },
  [`${REGION.SG}-${MARKETPLACE.CG}`]: {
    ...commonConfig,
    GOOGLE_CLIENT_ID: '185477762030-7l11il66to9h3nours87e2oo4dfcvf9o.apps.googleusercontent.com',
    FACEBOOK_CLIENT_ID: '1488923501265140',
    GURULAND_HOST: 'https://www.staging.commercialguru.com.sg',
    SYMBIOSIS_API_HOST: 'https://symbiosis.staging.commercialguru.com.sg',
  },
  [`${REGION.MY}-${MARKETPLACE.PG}`]: {
    ...commonConfig,
    GOOGLE_CLIENT_ID: '593435227081-ekv2tve0psovos0ibdm0hrdgsapsq6vc.apps.googleusercontent.com',
    FACEBOOK_CLIENT_ID: '1120584444623241',
    GURULAND_HOST: 'https://www.staging.propertyguru.com.my',
    SYMBIOSIS_API_HOST: 'https://symbiosis.staging.propertyguru.com.my',
  },
  [`${REGION.TH}-${MARKETPLACE.PG}`]: {
    ...commonConfig,
    GOOGLE_CLIENT_ID: '711575025382-2l4p4olfv5mkrqak673e6u38ike9lcei.apps.googleusercontent.com',
    FACEBOOK_CLIENT_ID: '727074891972539',
    GURULAND_HOST: 'https://www.staging.ddproperty.com',
    SYMBIOSIS_API_HOST: 'https://symbiosis.staging.ddproperty.com',
  },
  [`${REGION.ID}-${MARKETPLACE.PG}`]: {
    ...commonConfig,
    GOOGLE_CLIENT_ID: '170928738109-ih2t278kagbg8esmgc7d6ucmov1sujc6.apps.googleusercontent.com',
    FACEBOOK_CLIENT_ID: '1691036877799377',
    GURULAND_HOST: 'https://www.staging.rumah.com',
    SYMBIOSIS_API_HOST: 'https://symbiosis.staging.rumah.com',
  },
};

export default config;
